module.exports = __webpack_public_path__ + "static/media/AktivGrotesk-Medium.43a86a30.woff";